import { render } from "./stage5.vue?vue&type=template&id=5ae38ca5&scoped=true"
import script from "./stage5.vue?vue&type=script&lang=js"
export * from "./stage5.vue?vue&type=script&lang=js"

import "./stage5.vue?vue&type=style&index=0&id=5ae38ca5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae38ca5"]])

export default __exports__